import * as go from 'gojs';
import * as React from 'react';
import { noop } from 'vet-bones/utils';

export type DiagramSelectionValue = [
  go.Set<go.Part>,
  (selection: go.Set<go.Part>) => void
];

export const SelectionContext = React.createContext<DiagramSelectionValue>([
  new go.Set(),
  noop,
]);

export const useDiagramSelection = () => {
  const [selection] = React.useContext(SelectionContext);
  return selection;
};

export const useSetDiagramSelection = () => {
  const [, setDiagramSelection] = React.useContext(SelectionContext);
  return setDiagramSelection;
};

export const useDiagramSelectionValue = (): DiagramSelectionValue => {
  const [selection, setSelection] = React.useState<go.Set<go.Part>>(
    new go.Set()
  );
  return [selection, setSelection];
};
